import { BOARD_CONFIG } from "@/config/browserBoard";

const API_UI_PATH = "/ui";

/** APIドキュメントの公開URLを、設定されたAPI originから組み立てる。 */
export function getApiUiUrl(baseUrl?: string): string {
  const configuredBaseUrl = baseUrl ?? BOARD_CONFIG.apiBaseUrl;

  if (!configuredBaseUrl.trim()) {
    return API_UI_PATH;
  }

  return `${configuredBaseUrl.replace(/\/+$/, "")}${API_UI_PATH}`;
}
